import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from 'src/components/common/Icon';
import LiquidGlassEffect from 'src/components/common/LiquidGlassEffect';
import { ADD_ROUTE } from 'src/constants/routes';

import css from './Controls.module.scss';

type Props = {
  onAdd?: () => void;
};

export default function Controls({ onAdd }: Props) {
  const navigate = useNavigate();
  const handleAdd = onAdd ?? (() => navigate(ADD_ROUTE));

  return (
    <div className={css.controls}>
      <LiquidGlassEffect>
        <div className={css.buttons}>
          <button type="button" className={css.addBtn} onClick={handleAdd}>
            <Icon type="plus" />
          </button>
        </div>
      </LiquidGlassEffect>
    </div>
  );
}
